let md5 = require('md5')

export default {
  encripMD5 (info) {
    return md5(info)
  }
}